import mod from "-!./downloadFile.js?vue&type=script&lang=js&external"; export default mod; export * from "-!./downloadFile.js?vue&type=script&lang=js&external"